import { useCallback } from 'react';
import { ViewSectionUuid } from '../../../data-models/view-config.data-model';
import { ViewModel } from '../../../models/view.model';
import { useView } from '../hooks/useView';

// Per-view component visibility for the fund page sections, stored as
// config.order.components[sectionId] like the company sections. `undefined`
// means never configured (fall back to the code defaults); an explicit empty
// array means the user removed everything and the section hides entirely.
export function useFundSectionComponents(
  view: ViewModel,
  sectionId: ViewSectionUuid,
  defaults: readonly string[]
) {
  const { setComponentsOrder } = useView();

  const saved = view.order?.components?.[sectionId];
  const componentIds: readonly string[] = saved ?? defaults;

  const setComponentIds = useCallback(
    (ids: string[]) => setComponentsOrder(sectionId, ids),
    [sectionId, setComponentsOrder]
  );

  return { componentIds, setComponentIds };
}
